<template>
  <div class="h-100 d-block">
    <b-table
      class="h-100 d-flex"
      striped
      hover
      responsive
      bordered
      :fields="fields"
      :items="dataList"
      small
    >
      <template #cell(brand)="data">
        {{ data.item.brand }}
      </template>
      <template #cell(yearly)="data">
        <div :class="data.item.yearly < 0? 'text-danger' : ''">
          %{{ data.item.yearly | toNumber }}
        </div>
      </template>
      <template #cell(yearly_amount)="data">
        <div :class="data.item.yearly_amount < 0? 'text-danger' : ''">
          {{ data.item.yearly_amount | toCurrency }}₺
        </div>
      </template>
      <template #cell(monthly)="data">
        <div :class="data.item.monthly < 0? 'text-danger' : ''">
          %{{ data.item.monthly | toNumber }}
        </div>
      </template>
      <template #cell(monthly_amount)="data">
        <div :class="data.item.monthly_amount < 0? 'text-danger' : ''">
          {{ data.item.monthly_amount | toCurrency }}₺
        </div>
      </template>
    </b-table>
  </div>
</template>
<script>
import { BTable } from 'bootstrap-vue'

export default {
  name: 'TableBrandProfitability',
  components: { BTable },
  props: {
    dataList: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      fields: [
        {
          key: 'brand',
          label: 'Marka',
          sortable: true,
          thClass: 'font-small-2 align-middle text-nowrap',
          tdClass: 'font-weight-bold text-body text-nowrap',
        },
        {
          key: 'monthly',
          label: 'Aylık %',
          sortable: true,
          thClass: 'font-small-2 width-100 text-right align-middle text-nowrap',
          tdClass: 'text-right text-nowrap text-body',
        },
        {
          key: 'yearly',
          label: 'Yıllık %',
          sortable: true,
          thClass: 'font-small-2 width-100 text-right align-middle text-nowrap',
          tdClass: 'text-right text-body',
        },
        {
          key: 'monthly_amount',
          label: 'Aylık ₺',
          sortable: true,
          thClass: 'font-small-2 width-150 text-right align-middle text-nowrap',
          tdClass: 'text-right text-nowrap text-body',
        },
        {
          key: 'yearly_amount',
          label: 'Yıllık ₺',
          sortable: true,
          thClass: 'font-small-2 width-150 text-right align-middle text-nowrap',
          tdClass: 'text-right text-body',
        },
      ],
    }
  },
}
</script>
